import React from 'react'

import ESignatureLetterModal, {
  ESignatureLetterModalProps,
} from '@/components/modals/EditESignatureLetterModal/ESignatureLetterModal'
import { usePreviewESignatureLetterModal } from '@/components/modals/PreviewESignatureLetterModal/usePreviewESignatureLetterModal'

type Props = Omit<ESignatureLetterModalProps, 'isShowing' | 'onHide'>

const PreviewESignatureLetterModal: React.FC<Props> = (props) => {
  const { isShowing, hidePreview } = usePreviewESignatureLetterModal()

  return (
    <ESignatureLetterModal
      {...props}
      isShowing={isShowing}
      onHide={hidePreview}
    />
  )
}

export default PreviewESignatureLetterModal
